import { Component, OnInit, LOCALE_ID, Inject } from '@angular/core';
import { WhatsAppReportService } from '../services/whatsapp-report.service';
import { LoginService } from '../login.service';
import { registerLocaleData } from '@angular/common';
import localeDeDE from '@angular/common/locales/de';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';

registerLocaleData(localeDeDE);

@Component({
  selector: 'app-whatsapp-sent-report',
  templateUrl: './whatsapp-sent-report.component.html',
  styleUrls: ['./whatsapp-sent-report.component.css'],
  providers: [{ provide: LOCALE_ID, useValue: 'de-DE' }]
})
export class WhatsAppSentReportComponent implements OnInit {
  reports: any[] = [];
  loading = false;
  startDatePicker: any;
  endDatePicker: any;
  myOptions: INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
  };

  filters = {
    start_date: '',
    end_date: '',
    status: '',
    phone_number: '',
    message_type: ''
  };

  statusOptions = [
    { value: '', label: 'All Status' },
    { value: 'sent', label: 'Sent' },
    { value: 'delivered', label: 'Delivered' },
    { value: 'read', label: 'Read' },
    { value: 'failed', label: 'Failed' }
  ];

  message_typeOptions = [
    { value: '', label: 'All' },
    { value: 'UTILITY', label: 'UTILITY' },
    { value: 'MARKETING', label: 'MARKETING' }
  ];
  currentUser: any;

  constructor(private reportService: WhatsAppReportService, private loginservice: LoginService) { }

  ngOnInit() {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this.setDefaultDates();
    this.loadReports();
  }

  setDefaultDates() {
    const today = new Date();
    const lastWeek = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);

    this.startDatePicker = this.formatDateForPicker(lastWeek);
    this.endDatePicker = this.formatDateForPicker(today);

    this.filters.start_date = this.formatYMD(this.startDatePicker);
    this.filters.end_date = this.formatYMD(this.endDatePicker);
  }

  onStartDateChanged(event: IMyDateModel): void {
    this.startDatePicker = event;
    this.filters.start_date = this.formatYMD(event);
    this.onFilterChange();
  }

  onEndDateChanged(event: IMyDateModel): void {
    this.endDatePicker = event;
    this.filters.end_date = this.formatYMD(event);
    this.onFilterChange();
  }

  formatDateForPicker(dateObj: Date) {
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();

    return {
      date: { year: year, month: month, day: day },
      jsdate: dateObj.toISOString(),
      formatted: this.formatDDMMYYYY(day, month, year),
      epoc: Math.floor(dateObj.getTime() / 1000)
    };
  }

  formatDDMMYYYY(day: number, month: number, year: number): string {
    return this.pad(day) + '/' + this.pad(month) + '/' + year;
  }

  pad(n: number): string {
    return n < 10 ? '0' + n : n.toString();
  }

  formatYMD(obj: any) {
    if (!obj || !obj.date) return '';
    const d = obj.date;
    return `${d.year}-${('0' + d.month).slice(-2)}-${('0' + d.day).slice(-2)}`;
  }

  formatDateTime(dateTime: string): string {
    if (!dateTime || dateTime === '0000-00-00 00:00:00' || dateTime === null) {
      return '--';
    }
    const date = new Date(dateTime);
    if (isNaN(date.getTime())) {
      return '--';
    }
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  formatDate(date: Date): string {
    return date.toISOString().split('T')[0];
  }

  loadReports() {
    this.loading = true;
    this.reportService.getSentMessageReports(this.filters, this.currentUser.salon_id).subscribe(
      response => {
        this.reports = response.data || [];
        this.loading = false;
      },
      error => {
        console.error('Error loading reports:', error);
        this.loading = false;
      }
    );
  }

  onFilterChange() {
    this.loadReports();
  }

  clearFilters() {
    this.filters = {
      start_date: '',
      end_date: '',
      status: '',
      phone_number: '',
      message_type: ''
    };
    this.setDefaultDates();
    this.loadReports();
  }


  exportToCSV() {
    const csvData = this.convertToCSV(this.reports);
    this.downloadCSV(csvData, 'whatsapp-sent-report.csv');
  }

  private convertToCSV(data: any[]): string {
    const headers = ['Date', 'Phone', 'Customer Name', 'Message', 'Status', 'Sent At', 'Delivered At', 'Read At', 'Failure Reason'];
    const csvArray = [headers.join(',')];

    data.forEach(row => {
      const messageText = row.message_text ? row.message_text.replace(/"/g, '""') : '';
      const failureReason = row.failure_reason ? row.failure_reason.replace(/"/g, '""') : '';
      const csvRow = [
        row.sent_date,
        row.recipient_wa_id,
        row.customer_name || '',
        '"' + messageText + '"',
        row.status,
        row.sent_at || '',
        row.delivered_at || '',
        row.read_at || '',
        '"' + failureReason + '"'
      ];
      csvArray.push(csvRow.join(','));
    });

    return csvArray.join('\n');
  }

  private downloadCSV(csvData: string, filename: string) {
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
}


// WEBPACK FOOTER //
// ./src/app/whatsapp-sent-report/whatsapp-sent-report.component.ts